import React, { useEffect } from 'react';

/**
 * Circular Spinner that automatically adopts the current text color,
 * so it blends in with the rest of the project’s styling without
 * extra SCSS.  Place it inside the existing
 * `<div className="loading-spinner text-center">` wrapper.
 *
 * Example:
 *   <div className="loading-spinner text-center">
 *     <Spinner />
 *   </div>
 *
 * To change colour, simply set `color` on the parent:
 *   .loading-spinner { color: var(--primary-color); }
 */
function Spinner() {
  useEffect(() => {
    const STYLE_ID = 'mioo-global-spinner-styles';
    if (!document.getElementById(STYLE_ID)) {
      const styleTag = document.createElement('style');
      styleTag.id = STYLE_ID;
      styleTag.textContent = `
        @keyframes mioo-spin {
          to { transform: rotate(360deg); }
        }
        .mioo-spinner {
          width: 3rem;
          height: 3rem;
          border: 0.4rem solid rgba(0, 0, 0, 0.15);
          border-top-color: currentColor;
          border-radius: 50%;
          animation: mioo-spin 0.7s linear infinite;
        }
      `;
      document.head.appendChild(styleTag);
    }
  }, []);

  return <div className="mioo-spinner" />;
}

export default Spinner;
